module.exports = __webpack_public_path__ + "img/loading.a2d82b82.png";